import React from 'react'
import url from 'libraries/front-end-core/core/url'
import { MW_LIST_DEALS, SEARCH, SMART_SEARCH } from 'constants/controllers'
import cx from 'classnames'
import Link from '@mui/material/Link'
import ContainedButton from 'components/search/ContainedButton'

const getUrl = (_query, _flavour, searchType, searchTerm, isLogged, smartSearch) => {
  const flavour = searchType === 'qa' && _flavour
  const commonQuery = { q: searchTerm }

  // Add aol filter for search types other than documents and dealwatch
  if (!['documents', 'dealwatch'].some(nonAolSearchType => nonAolSearchType === searchType)) {
    commonQuery.aol = _query.aol
  }

  if (searchType === 'qa' && smartSearch) { // handle smart search enabled
    return url(SMART_SEARCH, { flavour }, commonQuery)
  }
  if (searchType !== 'dealwatch') { // standard url form for search buttons
    return url(SEARCH, { flavour, searchType }, commonQuery)
  } // sets the url for dealwatch only if the user is logged in)
  return isLogged ? url(MW_LIST_DEALS, { flavour, path: 'all' }, commonQuery) : null
}

const SearchTypeButton = ({
  query,
  searchTerm,
  selected,
  searchType,
  title,
  iconName,
  activeClass,
  isProxy = false,
  setSignUpModalIsOpen,
  isLogged,
  flavour,
  smartSearch
}) => {
  const linkStyle = selected ? { textDecoration: 'none' } : {}
  const activeCx = selected ? activeClass : ''
  const buttonCxNames = cx('ttc b f5', { 'bg-white ba b--cadet-blue': !selected }, activeCx)
  const url = selected || isProxy ? null : getUrl(query, flavour, searchType, searchTerm, isLogged, smartSearch)
  const handleOnClick = (e) => {
    selected
      ? e.preventDefault()
      : !isLogged && searchType === 'dealwatch' && setSignUpModalIsOpen(true)
  }

  return (
    <Link href={url} style={linkStyle} onClick={handleOnClick}>
      <ContainedButton {...{ buttonCxNames, selected, title, iconName, isProxy }} />
    </Link>
  )
}

export default SearchTypeButton
